// extracted by mini-css-extract-plugin
export default {"createButton":"createButton-3UAgy2","overflowOverride":"overflowOverride-3QlLNG","legalLinksSection":"legalLinksSection-PIFvHC"};